import React from 'react';
import classnames from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import ErrorBoundary from '../ErrorBoundary';
import LazyContext from '../LazyLoadingImage/LazyContext';
import SidebarBlock from './SidebarBlock';
import LoaderBlock from './_partials/LoaderBlock';
import s from './Sidebar.scss';
const Sidebar = ({ deviation , className  })=>{
    var _deviation_extended;
    const blocks = deviation === null || deviation === void 0 ? void 0 : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.relatedContent;
    const isLoading = !deviation.extended;
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "Sidebar"
    }, /*#__PURE__*/ React.createElement(LazyContext.Provider, {
        value: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className),
        role: "complementary"
    }, !isLoading && blocks && blocks.map((block)=>/*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            key: block.contentType,
            value: {
                _rankOffset: 0
            }
        }, /*#__PURE__*/ React.createElement(SidebarBlock, {
            block: block,
            deviation: deviation
        }))), isLoading && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LoaderBlock, {
        index: 0
    }), /*#__PURE__*/ React.createElement(LoaderBlock, {
        index: 1
    }), /*#__PURE__*/ React.createElement(LoaderBlock, {
        index: 2
    })))));
};
Sidebar.displayName = 'Sidebar';
export default Sidebar;
